/**
 * Browser notification permission states returned by:
 *
 * - Notification.permission
 * - Notification.requestPermission()
 */
export enum E_NOTIFICATION_PERMISSION {
  DEFAULT = "default",
  GRANTED = "granted",
  DENIED = "denied"
}

/**
 * Service-worker lifecycle states used by FirebaseStore.
 */
export enum E_SERVICE_WORKER_STATE {
  ACTIVATED = "activated",
  REDUNDANT = "redundant"
}

/**
 * Message types sent from firebase-messaging-sw.js
 * to the browser application.
 */
export enum E_FIREBASE_SERVICE_WORKER_MESSAGE_TYPE {
  BACKGROUND_MESSAGE = "FIREBASE_BACKGROUND_MESSAGE"
}

/**
 * Browser event names used by FirebaseStore.
 */
export enum E_FIREBASE_BROWSER_EVENT {
  MESSAGE = "message",
  STATE_CHANGE = "statechange"
}

/**
 * Service-worker registration cache behavior.
 */
export enum E_SERVICE_WORKER_UPDATE_VIA_CACHE {
  NONE = "none"
}

/**
 * Firebase-related browser error names.
 */
export enum E_FIREBASE_BROWSER_ERROR_NAME {
  ABORT_ERROR = "AbortError"
}

/**
 * Firebase service-worker configuration constants.
 */
export const FIREBASE_SERVICE_WORKER_SCOPE = "/";

export const FIREBASE_SERVICE_WORKER_ACTIVATION_TIMEOUT_MS = 20_000;

export const FIREBASE_SERVICE_WORKER_ACTIVATION_SETTLE_DELAY_MS = 200;

export const FIREBASE_TOKEN_RETRY_DELAY_MS = 500;

export const FIREBASE_TOKEN_MAX_ATTEMPTS = 2;

export const NO_ACTIVE_SERVICE_WORKER_ERROR_MESSAGE =
  "no active service worker";
